<template>
   <b-row v-bind:class="[{ busy: busy}, 'article-row-card', 'opacity-transition', 'mb-3']">
      <pb-spinner v-if="busy"></pb-spinner>
      <b-col md="2">
         <div class="image d-flex">
            <img style="cursor:pointer;" class="card-img-top" @click="fetchArticleDetails"
                 v-b-modal="'gallery-modal-' + article.id"
                 :src="imageResource(article.webImage || article.image, 250)"/>
         </div>
      </b-col>
      <b-col md="10">
         <div class="content p-3">
            <b-row class="article-subtitle">
               <b-col>
                  {{ article.name }}&nbsp;&nbsp;<span
                   v-if="customerArticleNumber">|&nbsp;&nbsp;{{ customerArticleNumber }}</span><span
                   v-if="selectedVariant">&nbsp;&nbsp;|&nbsp;&nbsp;<span class="icon-gts"></span>&nbsp;
                    <nobr>
                                                                                <b-link target="_blank"
                                                                                        :href="`https://gts.pranke.com/itemview?Nav=40&TypeS=ArticleDetail&Field=Sku&Search=DE.LAU.PET-BUE.0000-${selectedVariant.variationId}-0000`">DE.LAU.PET-BUE.0000-{{ selectedVariant.variationId }}-0000</b-link>

                    </nobr></span>
               </b-col>
            </b-row>
            <b-row class="mt-2">
               <b-col>
                  <span class="article-title">{{ article.primaryDescription || article.secondaryDescription }}</span>
               </b-col>
            </b-row>
            <b-row class="mt-3" v-if="isApproved">
               <b-col md="4">
                  <custom-select @click.native="fetchArticleDetails"
                                 type="sm"
                                 @select="(sizeId) => selectedSize = sizeId"
                                 :value="selectedSize" label="SIZE"
                                 :options="sizeOptions"></custom-select>
               </b-col>
               <b-col>
                  <custom-select @click.native="fetchArticleDetails"
                                 type="sm"
                                 @select="(colorId) => selectedColor = colorId"
                                 :value="selectedColor" label="COLOR"
                                 :options="colorOptions">
                  </custom-select>
               </b-col>
               <b-col class="m-auto">
                  <b-form-checkbox
                      v-if="showSelectCustomerModeSwitch && variantList"
                      v-model="colorSelectCustomerMode"
                      @click.stop="toggleColorSelectMode"
                      :unchecked-value="false"
                  >Show only customer colors
                  </b-form-checkbox>
               </b-col>
            </b-row>
            <b-row class="mt-3" align-v="center" v-if="isApproved">
               <b-col>
                  <b-link v-if="isApproved" variant="link" class="pl-0"
                          @click="openModal('modal-' + article.id)"
                  ><i class="fal fa-eye fa-2x"></i>DETAILS
                  </b-link>
                  <b-link
                      class="ml-3"
                      @click="openContactModal()"
                      variant="link"><i
                      v-if="article.contactRequests && article.contactRequests.length > 0"
                      class="fas fa-check-circle fa-2x"></i><i v-else
                                                               class="fal fa-envelope fa-2x"></i>MESSAGE
                  </b-link>

                  <b-link
                      class="ml-3"
                      @click="openNegativeStatementInfoModal()"
                      variant="link"><i class="fal fa-passport fa-2x"></i>DECLARATION OF ORIGIN
                  </b-link>
                  <div :id="'popover-button-event' + article.id" class="d-inline-block ml-3">
                     <b-link :id="'popover-button-event' + article.id"
                             @click="showDocuments()"
                             variant="link">
                        <i class="fa-download fal fa-2x"></i>
                        DOCUMENTS
                     </b-link>
                  </div>
                  <div :id="'popover-button-variant' + article.id" class="d-inline-block ml-3">
                     <pb-btn :busy="busyAddingSample" variant="link" as-link
                             :disabled="!selectedVariant || inSampleList"
                             @click.native="onRequestSample()">
                        <template slot="icon">
                           <i class="fal fa-swatchbook fa-2x"></i>
                        </template>
                        REQUEST SAMPLE
                     </pb-btn>
                  </div>
               </b-col>
            </b-row>
            <b-row class="mt-2" v-if="isApproved">
               <b-col>

                  <small class="text-danger text-right my-0" v-if="wasRecentlyUpdated()">Price for at least one
                     variant of this item was updated on
                     {{
                        article.lastPriceUpdateCustomer ? new
                        Date(article.lastPriceUpdateCustomer).toLocaleDateString() : new
                        Date(article.lastPriceUpdate).toLocaleDateString()
                     }}
                  </small>
               </b-col>
            </b-row>
            <b-row class="mt-1" v-else>
               <b-col class="m-auto">
                  <p>Article details are currently getting created</p>
               </b-col>
            </b-row>
         </div>
         <b-popover v-if="!selectedVariant || inSampleList" triggers="hover"
                    :target="'popover-button-variant' + article.id"
                    variant="warning"
                    placement="top">
            <div v-if="inSampleList">
               Article variant is already in your sample list
            </div>
            <div v-else>{{ $t("invalid_color_and_size_selection") }}</div>
         </b-popover>
      </b-col>
      <b-modal size="lg" :ref="'modal-' + article.id" :id="'modal-' + article.id" :article="article"
               :title="article.name">
         <b-container v-bind:class="[{ busy: busy || loadingVariantList}, 'opacity-transition']">
            <pb-spinner v-if="busy || loadingVariantList"></pb-spinner>
            <b-row>
               <b-col>
                  <h4 class="text-center">Article Details</h4>
                  <hr/>
                  <pb-article-details-table v-if="articleDetails"
                                            :article="articleDetails"
                                            :variant="selectedVariant"></pb-article-details-table>
               </b-col>
            </b-row>
            <b-row class="mt-5" v-if="colorSizeMatrix && colorSizeMatrix.length > 0">
               <b-col>
                  <h4 class="text-center">Stock Information</h4>
                  <hr/>
                  <pb-article-stock-table
                      :colorSizeMatrix="colorSizeMatrix"></pb-article-stock-table>
               </b-col>
            </b-row>
         </b-container>
      </b-modal>
      <contact-modal
          :ref="'contact-modal-' + article.id"
          :id="'contact-modal-' + article.id"
          :article="article"
          :subject="contactSubject">
      </contact-modal>
      <negative-statement-modal
          :article-details="articleDetails"
          :ref="'negative-statement-modal-' + article.id"
          :category="category"
          :id="'negative-statement-modal-' + article.id"
          :article="article">
      </negative-statement-modal>
      <negative-statement-info-modal
          @negative="openNegativeStatementModal()"
          @contact="openContactModal(3)"
          :article-details="articleDetails"
          :ref="'negative-statement-info-modal-' + article.id"
          :category="category"
          :id="'negative-statement-info-modal-' + article.id"
          :article="article">
      </negative-statement-info-modal>
      <b-modal size="lg" :id="'gallery-modal-' + article.id" :ref="'gallery-modal-' + article.id" hide-footer
               hide-header>
         <b-container class="text-left" style="min-height: 200px;">
            <b-row v-bind:class="[{ busy: busy || loadingPrice}, 'opacity-transition', 'mb-3']">
               <pb-spinner v-if="busy || loadingPrice"></pb-spinner>
               <b-col>
                  <ImageGallery v-if="articleDetails" ref="gallery" :images="imageList"/>
               </b-col>
            </b-row>
         </b-container>
      </b-modal>
      <b-modal ok-only center :ref="'documents-' + article.id" :title="`Article ${article.name}`">
         Documentlist:
         <ul class="list-unstyled ml-4" v-if="articleDetails">
            <li>

               <pb-btn :busy="loadingExport" href="#"
                       icon="fa-file-pdf"
                       @click.native="loadArticlePdf"
                       variant="link">
                  Details & Pricing
               </pb-btn>

            </li>
            <li v-if="link3D">
               <pb-btn :href="link3D"
                       target="_blank"
                       icon="fa-cube"
                       variant="link">
                  3D Model
               </pb-btn>
            </li>
            <li :key="index" v-for="(file,index) in fileList">
               <pb-btn variant="link"
                       icon="fa-image"
                       v-if="(/\.(gif|jpg|jpeg|tiff|png)$/i).test(file.fileName)"
                       :href="fileResourceUrl(file)"
                       target="_blank">
                  {{ file.fileLabel }}
               </pb-btn>
               <pb-btn variant="link"
                       icon="fa-file-video"
                       v-else-if="(/\.(mp4)$/i).test(file.fileName)"
                       :href="fileResourceUrl(file)"
                       target="_blank">
                  {{ file.fileLabel }}
               </pb-btn>
               <pb-btn variant="link" v-else
                       icon="fa-file-spreadsheet"
                       :href="fileResourceUrl(file)"
                       target="_blank">
                  {{ file.fileLabel }}
               </pb-btn>
            </li>
         </ul>
      </b-modal>
   </b-row>
</template>
<script>

import CustomerCategoryArticleBase from "./CustomerCategoryArticleBase";
import ArticleDetailsTable from "../../../components/article/ArticleDetailsTable";
import ArticleStockTable from "../../../components/article/ArticleStockTable";
import ContactModal from "../../../components/ui/ContactModal";
import NegativeStatementModal from "../../../components/ui/NegativeStatementModal";
import ImageGallery from "../../../components/ImageGallery";
import NegativeStatementInfoModal from "@client/src/viewsShop/components/ui/NegativeStatementInfoModal.vue";

export default {
   name: 'cutomer-category-article-basic',
   components: {
      NegativeStatementInfoModal,
      ContactModal,
      NegativeStatementModal,
      'pb-article-details-table': ArticleDetailsTable,
      'pb-article-stock-table': ArticleStockTable,
      'ImageGallery': ImageGallery,
   },
   extends: CustomerCategoryArticleBase,
   methods: {
      showDocuments() {

         this.fetchArticleDetails().then(() => {
            this.$refs['documents-' + this.article.id].show();
         })

      },
      onRequestSample() {
         if (window.$cookies.isKey('hideSamplePopup')) {
            this.onAddToSamples();
         } else {
            let selectedVariant = this.selectedVariant;
            if (selectedVariant) {
               this.$emit('addSampleItem', {
                  article: this.article,
                  variant: selectedVariant
               });
            }
         }
      },
      openModal() {

         this.fetchArticleDetails().finally(() => {
            this.$refs['modal-' + this.article.id].show();
         });

         if (!this.variantListLoaded) {
            this.loadArticleVariantList(this.article.id, this.category.id);
         }
      }
   }
}
</script>
